import localStorageService from "@/service/storage/localStorageService";
import {LOGIN_USER_INFO} from "@/service/keys";
import {loginAPI, logout} from '@/api/login';
import {variable} from "@/common/variable";
import axios from 'axios'
/**
 * 用户基础服务
 */
class UserService {

  // 用户登录
  login(params) {
    return new Promise((resolve, reject) => {
      loginAPI(params)
          .then(data => {
            // 存储到本地存储
            localStorageService.setObj(LOGIN_USER_INFO, data.data)
            setTimeout(() => {
              resolve(data)
            }, 200)
          })
          .catch(resp => {
            if (resp) {
              return reject(resp);
            }
            return reject();
          });
    })
  }

  // 注销登录
  logout(params) {
    return new Promise((resolve, reject) => {

      console.log(123)
      // 清除存储
      localStorageService.remove(LOGIN_USER_INFO)
      resolve()

      // logout(params)
      //     .then(data => {
      //       // 清除存储
      //       localStorageService.remove(LOGIN_USER_INFO)
      //       resolve()
      //     })
      //     .catch(resp => {
      //       if (resp) {
      //         reject(resp);
      //       }
      //       reject();
      //     });
    })
  }

  checkLogin() {
    return new Promise((resolve, reject) => {
      axios.get(variable.getServerUrl() + '!sys/security/~java/UpdateSession')
          .then(resp => {
            resolve(resp.data.header.code)
          })
          .catch(resp => {
            reject(-1)
          })
    })
  }

}

export default new UserService()